(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodClipboard', sodClipboard);

    function sodClipboard() {
        return {
            restrict: 'E',
            controller: sodClipboardCtrl,
            controllerAs: 'clip',
            bindToController: true,
            scope: {
                identifier: '=',
                value: '=',
            },
            template: '<div class="row collapse postfix-wrapper"><div class="columns small-11"><input style="background: white" type="text" class="font-small" id="<%clip.identifier%>" value="<%clip.value%>" readonly/></div><div class="columns small-1"><button kendo-tooltip="clip.tooltipObj" k-options="clip.tooltipOption" class="button postfix" id="<%clip.identifier%>-clipboard" data-clipboard-target="#<%clip.identifier%>"><i class="fa fa-clipboard"></i></button></div></div>',
        };
    }

    function sodClipboardCtrl($scope, $timeout) {
        this.$onInit = function() {
            var clip = this;
            clip.tooltipOption = {
                content: 'Copied!',
                showOn: 'click',
                position: 'top'
            };

            var clipboard = new Clipboard('#' + clip.identifier + '-clipboard');
            clipboard.on('success', function(e) {
                e.clearSelection();
            });
            clipboard.on('error', function(e) {
                console.error('Action:', e.action);
                console.error('Trigger:', e.trigger);
            });
            $scope.$on('$destroy', function(e) {
                clipboard.destroy();
            });
        }


    }
})();